import React, { PureComponent } from "react";
import { BrowserRouter as Router } from 'react-router-dom';
import { Col, Card, Row, Tabs, Pagination, Empty, Button, message } from 'antd';
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import './index.scss';
import imgDemo from '../../img/nb.png'
import { dataInfo } from "./fieldConfig";

export default class Index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            alliance: "",
            chairmanUnit: [],
            memberUnits: [],
            vicePresidentUnit: []
        };
    }

    componentDidMount() {
        const { } = this.props

        this.getInfoList()
        window.scrollTo(0, 0)
        document.documentElement.scrollTo(0, 0)
    }
    getInfoList = (data) => {
        const { } = this.state
        let params = {}
        Http.get(Request.educationTrainingAlliance(), { ...params }, obj => {
            if (obj.code == 200) {
                this.setState(obj.data.data)
                // this.setState(dataInfo)
                console.log('------getInfoList------', obj.data.data);
            } else {
                message.error(obj.msg || obj.message || "请求失败，请重试");
            }
        });


    }
    renderListInfo = (data) => {

    }
    handleClick = (e) => {
        const { history } = this.props;
        e.persist();
        let id = 100;
        console.log('------handleClick------', e);
        history.push(`./educationTrainingAllianceDetail/${id}`)
    }

    render() {
        const { handleClick } = this
        const { alliance, chairmanUnit, memberUnits, vicePresidentUnit } = this.state

        return (
            <div className="education_training_alliance">
                <div className="title_banner">
                    <h2>{alliance.institutionName || '退役军人教育培训联盟'}</h2>
                    <p>{alliance.briefIntroduction || '主要是为了推动和帮助退役军人完成第二次再就业，在四川省委省政府的领导下、眉山市委市政府的监管下特成立“眉山市退役军人教育培训联盟”'}</p>
                </div>
                <div className="unit_container">
                    <div className="chairman">
                        <h1> <span className="icon_title"></span> <span>会长单位</span></h1>
                        <div className="unit_profile" onClick={handleClick} data-index="0">
                            <div className="profile_container">
                                <div className="profile_left">
                                    <img src={chairmanUnit.image || imgDemo} alt="" srcset="" />
                                </div>
                                <div className="profile_right">
                                    <div className="profile_right_title">{chairmanUnit.institutionName}</div>
                                    <div className="profile_right_content">{chairmanUnit.briefIntroduction}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="vice_chairman">
                        <h1>副会长单位</h1>
                        <div className="unit_list">
                            {
                                vicePresidentUnit.map(item => (
                                    <div className="unit_item" onClick={handleClick} data-index={item}>
                                        <span className="unit_logo"><img src={item.image || imgDemo} alt="" srcset="" /></span>
                                        <span className="unit_name">{item.institutionName}</span>
                                        <span className="icon_more"></span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="member_units">
                        <h1>会员单位</h1>
                        <div className="unit_list">
                            {
                                memberUnits.map(item => (
                                    <div className="unit_item" onClick={handleClick} data-index={item} style={{ width: '370px' }}>
                                        <span className="unit_logo"><img src={item.image || imgDemo} alt="" srcset="" /></span>
                                        <span className="unit_name">{item.institutionName}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
